import { render, staticRenderFns } from "./TNewsContent.vue?vue&type=template&id=694ae4b4&"
import script from "./TNewsContent.vue?vue&type=script&lang=js&"
export * from "./TNewsContent.vue?vue&type=script&lang=js&"
import style0 from "./TNewsContent.vue?vue&type=style&index=0&id=694ae4b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports